import "./Roster.module.css";
import Header from "@/reusable_sections/Header";
import LEspritUzesInside from "./sections/LEspritUzesInside";
import ProjectGallery from "./sections/ProjectGallery";
import TeamMembersGrid from "./sections/TeamMembersGrid";
import GamingSocialFooter from "@/reusable_sections/Footer";
export default function RosterPage() {
  return <div>
      <Header />
      <LEspritUzesInside />
      <TeamMembersGrid />
      <ProjectGallery />
      <GamingSocialFooter />
    </div>;
}